module.exports = __webpack_public_path__ + "img/big-plus.dbd0a495.svg";